import * as React from 'react';


export default class Diaryies extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
		  <path d="M9.92383 20.5199L8.75 21.9285V16.75H12.25V21.9285L11.0762 20.5199L10.5 19.8285L9.92383 20.5199Z" fill="#333333" stroke="#333333" strokeWidth="1.5"/>
		<path d="M15 19H21V3H5V19H6" stroke="#333333" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
		<path d="M17 19V3" stroke="#333333" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    )
  }
}
